<template>
  <div>
    <label class="field_label">{{ current_champ.label }}<span class="text-red" v-if="current_champ.mandatory == 1">*</span></label>
    <v-text-field
      type="date"
      v-model="current_champ.value"
      @change="change_identity_current_coureur(current_champ.nom)"
      ref="field"
      @blur="$refs.field.validate()"
      :disabled="current_champ.disabled || is_disable"
      :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode)]"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  props: ["champ", "inscription", "mode", "is_disable"],
  data() {
    return {
      current_champ: {},
    };
  },
  watch: {
    champ: {
      deep: true,
      handler() {
        this.current_champ = this.champ;
        this.$forceUpdate();
      },
    },
  },
  methods: {
    change_identity_current_coureur(champ) {
      let identity_champs = ["nom", "prenom", "date_naissance", "sexe"];
      if (identity_champs.includes(champ) && this.inscription.coureur.id != null) {
        this.$emit("change_identity_coureur", this.inscription.coureur);
      }
    },
  },
  created() {
    this.current_champ = this.champ;
  },
};
</script>

<style lang="scss" scoped>
</style>